<div class="reset-password-page">
<app-l-header></app-l-header>
<!-- End Navbar -->
<div class="wrapper wrapper-full-page">
  <div class="page-header login-page header-filter" filter-color="black" style="background-image: url('../../../assets/img/collegedreams.jpg'); background-size: cover; background-position: top center;">
    <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
    <div class="container end">
      <div class="row login-cards">
        <div class="col">
          <div class="d-flex align-items-start flex-column" style="height: 200px;">
            <!--<div class="mb-5 p-2"></div>-->
            <div class="p-5 pg1 text-center">
              We’ll help you recover your <br>account in a few steps.
            </div>
            <div class="p-2 pg2">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              Enter your email address
            </div>
            <div class="p-2 pg2">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              Check your inbox for a password reset link
            </div>
            <div class="p-2 pg2">
              <i class="fa fa-check-circle" aria-hidden="true"></i>
              Click on the link to reset password
            </div>
          </div>
        </div>
      <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
        <div class="card card-login card-hidden">
          <div class="card-header text-center">
            <h4 class="card-title">Reset Password</h4>
            <!--<div class="social-line">
              Set new password for your account
            </div>-->
          </div>
          <form novalidate  #ResetForm="ngForm" (ngSubmit)="resetPassword()">
            <div class="card-body">
              <div class="bmd-form-group pb-3">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="material-icons">lock_outline</i>
                    </span>
                  </div>
                  <input class="form-control" placeholder="Enter new password"
                         type="password"
                         #password="ngModel" minlength="7" id="password"
                         [(ngModel)]="credentials.password"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
                <div class="text-danger pl-4"
                     *ngIf="password.errors && (password.dirty || password.touched)"
                     style="margin-top: -5px;">
                  <span class="validation-message" [hidden]="!password.hasError('minlength')">
                 Invalid password</span>
                  <span class="validation-message" [hidden]="!password.hasError('required')">
                 Password is required</span>
                </div>
              </div>
              <div class="bmd-form-group pb-3">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="material-icons">lock_outline</i>
                    </span>
                  </div>
                  <input class="form-control" placeholder="Confirm new password" type="password"
                         #reenterPassword="ngModel" minlength="7" id="reenterPassword"
                         [(ngModel)]="credentials.password_confirmation" [ngModelOptions]="{standalone: true}" required>


                </div>
                <div class="text-danger pl-4"  *ngIf="reenterPassword.errors && (reenterPassword.dirty || reenterPassword.touched)" style="margin-top: -5px;">
                  <span class="validation-message" [hidden]="!reenterPassword.hasError('minlength')">
                 Invalid password
                  </span>
                  <span class="validation-message" [hidden]="!reenterPassword.hasError('required')">
                 Password is required
                  </span>
                </div>
                <div class="text-danger pl-4"  *ngIf="reenterPassword.dirty && password.touched" style="margin-top: -5px;">
                  <span class="validation-message" [hidden]="credentials.password === credentials.password_confirmation ">
                 Password must match</span>
                </div>
              </div>

            </div>
            <div class="card-footer justify-content-center">
              <button type="submit" class="reset-button" [disabled]="password.errors || reenterPassword.errors || (credentials.password !== credentials.password_confirmation)">
                <i class="fa fa-spinner fa-spin" *ngIf="loaders.loading"></i>
                &nbsp;Reset Password
              </button>
            </div>

            <div style="font-size: 13px;">
              <p class="text-center px-2 pb-3">
                Don't Want to Reset Password?
                <a href="javascript:void(0)" [routerLink]="['/login']" class="text-rose">
                  Login
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
      </div>
    </div>

    <footer class="footer">
      <app-l-footer></app-l-footer>
    </footer>
  </div>
</div>
